import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';

import { withAuthGuard } from 'ggApp/modules/router/hocs';
import NewCheckoutScreenComponent from 'ggApp/shared/screens/NewCheckout';

import CheckoutWrap from './_wrap';
import CheckoutAddressWrap from './address/_wrap';
import CheckoutAddress from './address/address';
import CheckoutAddressCreate from './address/addressCreate';
import CheckoutAddressEdit from './address/addressEdit';

import CheckoutPayment from './payment/payment';

import CheckoutSummary from './summary';

const CheckoutRoutes = ({ newCheckoutFlag }) => {
    if (newCheckoutFlag) {
        return (
            <Route path="checkout" component={NewCheckoutScreenComponent}>
                <IndexRedirect to="address" />
                <Route path="address" component={NewCheckoutScreenComponent} />
                <Route path="payment" component={NewCheckoutScreenComponent} />
                <Route path="summary" component={NewCheckoutScreenComponent} />
            </Route>
        );
    }
    return (
        <Route path="checkout" component={withAuthGuard(CheckoutWrap)}>
            <IndexRedirect to="address" />
            <Route path="address" component={CheckoutAddressWrap}>
                <IndexRoute
                    name="checkoutAddress"
                    navigatorName="address"
                    component={CheckoutAddress}
                    orderStep={{
                        state: 'address',
                        step: 'address',
                    }}
                />
                <Route
                    path="create"
                    name="checkoutAddressCreate"
                    navigatorName="address"
                    component={CheckoutAddressCreate}
                    orderStep={{
                        state: 'address',
                        step: 'address',
                    }}
                />
                <Route
                    path="edit/:addressId"
                    name="checkoutAddressEdit"
                    navigatorName="address"
                    component={CheckoutAddressEdit}
                    orderStep={{
                        state: 'address',
                        step: 'address',
                    }}
                />
            </Route>

            <Route
                path="payment"
                name="checkoutPayment"
                navigatorName="payment"
                component={CheckoutPayment}
                orderStep={{
                    state: 'payment',
                    step: 'payment',
                }}
            />

            <Route
                path="summary"
                name="checkoutSummary"
                navigatorName="overview"
                component={CheckoutSummary}
                orderStep={{
                    state: 'summary',
                    step: 'summary',
                }}
            />
        </Route>
    );
};

export default CheckoutRoutes;
